import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';

import { User } from 'src/app/models/User';
import { AppAuthenticationReport } from 'src/app/models/app-authentication-report.model';
import { AppAuthenticationReportService } from 'src/app/shared/services/app-authentication-report.service';
import { AuthService } from 'src/app/shared/services/auth.service';
import { ADMINISTRATOR } from 'src/app/shared/services/user.service';
import { toLocalISODate } from 'src/app/shared/utils';

@Component({
  selector: 'app-app-authentication-report',
  templateUrl: './app-authentication-report.component.html',
  styleUrls: ['./app-authentication-report.component.scss'],
})
export class AppAuthenticationReportComponent implements OnInit, OnDestroy {
  user: User;
  loading = false;

  startDate: Date;
  endDate: Date;
  filterEmail: string = null;

  items: AppAuthenticationReport[] = [];
  total = 0;
  currentPage = 1;
  perPage = 50;

  subscriptions: Subscription[] = [];

  get administrator(): boolean {
    return this.user.profile_id === ADMINISTRATOR;
  }

  get totalPages(): number {
    return Math.max(1, Math.ceil(this.total / this.perPage));
  }

  constructor(
    private router: Router,
    private authService: AuthService,
    private reportService: AppAuthenticationReportService,
  ) {}

  ngOnInit(): void {
    this.user = this.authService.getUser();

    if (!this.administrator) {
      this.router.navigate(['/dashboard']);
      return;
    }

    const today = new Date();
    const thirtyDaysAgo = new Date();
    thirtyDaysAgo.setDate(today.getDate() - 30);

    this.endDate = today;
    this.startDate = thirtyDaysAgo;

    this.filter();
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(s => s.unsubscribe());
  }

  filter(): void {
    this.currentPage = 1;
    this.search();
  }

  onPageChange(page: number): void {
    if (page < 1 || page > this.totalPages || page === this.currentPage) {
      return;
    }
    this.currentPage = page;
    this.search();
  }

  clear(): void {
    const today = new Date();
    const thirtyDaysAgo = new Date();
    thirtyDaysAgo.setDate(today.getDate() - 30);

    this.endDate = today;
    this.startDate = thirtyDaysAgo;
    this.filterEmail = null;
    this.filter();
  }

  trackById(_: number, item: AppAuthenticationReport): string {
    return `${item.email}-${item.created_at}`;
  }

  private search(): void {
    this.loading = true;
    this.items = [];

    this.subscriptions.push(
      this.reportService
        .getReport(
          this.startDate ? toLocalISODate(this.startDate) : undefined,
          this.endDate ? toLocalISODate(this.endDate) : undefined,
          this.filterEmail || undefined,
          this.currentPage,
          this.perPage,
        )
        .subscribe({
          next: (response) => {
            this.items = response.data;
            this.total = response.total;
            this.currentPage = response.current_page;
            this.loading = false;
          },
          error: () => {
            this.loading = false;
          },
        })
    );
  }
}
